<template>
	<el-row>
		<el-col :span="11">
			<el-input placeholder="纬度(Lat)" v-model="Lat" autocomplete="off" :size="$store.state.isphone?'mini':''"></el-input>
		</el-col>
		<el-col :span="2">
			<div class="center-dh" :style="'line-height: '+($store.state.isphone?'27px;':'40px;')">,</div>
		</el-col>
		<el-col :span="11">
			<el-input placeholder="经度(Lng)" v-model="Lng" autocomplete="off" :size="$store.state.isphone?'mini':''"></el-input>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods:{
			
		},
		props: {
			value: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			Lng: {
				get () {
					if(this.value==null||this.value==''||this.value.indexOf(',')==-1)
					{
						return '';
					}
					else
					{
						return this.value.split(',')[1];
					}
				},
				set (value) {
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.Lat+','+value);
					}
					o.input();
				}
			},
			Lat: {
				get () {
					if(this.value==null||this.value==''||this.value.indexOf(',')==-1)
					{
						return '';
					}
					else
					{
						return this.value.split(',')[0];
					}
				},
				set (value) {
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', value+','+this.Lng);
					}
					o.input();
				}
			}
		}
	}
</script>

<style scoped>
	.center-dh{
		text-align: center;
		font-size: 20px;
	}
</style>
